// Simple translations dictionary for TR/EN/AR/RU
export const STRINGS = {
  tr: {
    nav_home: "Ana Sayfa",
    nav_treatments: "Tedaviler",
    nav_about: "Hakkında",
    nav_contact: "İletişim",
    hero_kicker: "AMELİYATSIZ GENÇLEŞTİRME",
    hero_title: "Doğal güzelliğin\nyeniden keşfi",
    hero_sub: "Dr. Hüseyin Tırman ile yüz ve vücudunuz için ameliyatsız, kişiye özel tedavi yolculuğu.",
    hero_cta: "Yapay zeka asistanıyla konuş",
    hero_secondary: "Hizmetleri keşfet",
    section_services: "Tedavi Alanları",
    section_about_title: "Estetiğin sanatsal dokunuşu",
    section_about_text: "20 yılı aşkın tecrübeyle ameliyatsız yüz ve vücut tedavilerinde öncü. Her bir uygulama, kişiye özel olarak planlanır.",
    contact_title: "İletişim",
    contact_phone: "Telefon",
    contact_email: "E-posta",
    contact_address: "Adres",
    address: "Levent, İstanbul",
    services: [
      { title: "Yüz Tedavileri", desc: "Mezoterapi, dolgu, ipli askı, lazer gençleştirme." },
      { title: "Vücut Tedavileri", desc: "Bölgesel incelme, selülit, sıkılaştırma uygulamaları." },
      { title: "Saç Tedavileri", desc: "PRP, mezoterapi, saç dökülmesi tedavileri." },
      { title: "Cilt Bakımı", desc: "Premium cilt bakımı ve leke tedavileri." },
    ],
    chat_title: "AI Konsültasyon",
    chat_subtitle: "Bilgin — Dr. Tırman'ın AI asistanı",
    chat_placeholder: "Sorunuzu yazın veya mikrofona basın...",
    chat_send: "Gönder",
    chat_listening: "Dinleniyor...",
    chat_processing: "İşleniyor...",
    chat_voice_on: "Sesli yanıt açık",
    chat_voice_off: "Sesli yanıt kapalı",
    lead_title: "İletişim Bilgileriniz",
    lead_sub: "Sizi nasıl arayabiliriz?",
    lead_name: "Ad Soyad",
    lead_method: "Tercih ettiğiniz iletişim",
    lead_phone: "Telefon",
    lead_email: "E-posta",
    lead_whatsapp: "WhatsApp",
    lead_value: "İletişim bilgisi",
    lead_submit: "Gönder",
    lead_thanks: "Teşekkürler! En kısa sürede size ulaşacağız.",
    welcome: "Merhaba 👋 Ben Bilgin — Dr. Hüseyin Tırman'ın yapay zeka asistanıyım. Size tedaviler, fiyatlar, kampanyalar veya randevu konularında yardımcı olabilirim. Sesle veya yazarak sorabilirsiniz.",
  },
  en: {
    nav_home: "Home",
    nav_treatments: "Treatments",
    nav_about: "About",
    nav_contact: "Contact",
    hero_kicker: "NON-SURGICAL REJUVENATION",
    hero_title: "Rediscovering\nnatural beauty",
    hero_sub: "Personalised, non-surgical face and body treatment journey with Dr. Hüseyin Tırman.",
    hero_cta: "Talk to AI assistant",
    hero_secondary: "Explore services",
    section_services: "Treatment Areas",
    section_about_title: "An artistic touch in aesthetics",
    section_about_text: "Pioneering non-surgical face and body treatments with over 20 years of experience. Every application is planned specifically for you.",
    contact_title: "Contact",
    contact_phone: "Phone",
    contact_email: "Email",
    contact_address: "Address",
    address: "Levent, Istanbul",
    services: [
      { title: "Face Treatments", desc: "Mesotherapy, fillers, thread lift, laser rejuvenation." },
      { title: "Body Treatments", desc: "Slimming, cellulite, firming applications." },
      { title: "Hair Treatments", desc: "PRP, mesotherapy, hair-loss therapies." },
      { title: "Skin Care", desc: "Premium skin care and pigmentation treatments." },
    ],
    chat_title: "AI Consultation",
    chat_subtitle: "Bilgin — Dr. Tırman's AI assistant",
    chat_placeholder: "Type a question or press the mic...",
    chat_send: "Send",
    chat_listening: "Listening...",
    chat_processing: "Processing...",
    chat_voice_on: "Voice on",
    chat_voice_off: "Voice off",
    lead_title: "Your contact details",
    lead_sub: "How may we reach you?",
    lead_name: "Full name",
    lead_method: "Preferred contact",
    lead_phone: "Phone",
    lead_email: "Email",
    lead_whatsapp: "WhatsApp",
    lead_value: "Contact",
    lead_submit: "Submit",
    lead_thanks: "Thanks! We will reach out shortly.",
    welcome: "Hello 👋 I'm Bilgin — Dr. Hüseyin Tırman's AI assistant. I can help with treatments, pricing, campaigns or appointments. You can ask by voice or text.",
  },
  ar: {
    nav_home: "الرئيسية",
    nav_treatments: "العلاجات",
    nav_about: "من نحن",
    nav_contact: "اتصال",
    hero_kicker: "تجديد الشباب بدون جراحة",
    hero_title: "إعادة اكتشاف\nالجمال الطبيعي",
    hero_sub: "رحلة علاج شخصية للوجه والجسم بدون جراحة مع الدكتور حسين تيرمان.",
    hero_cta: "تحدث مع المساعد الذكي",
    hero_secondary: "استكشف الخدمات",
    section_services: "مجالات العلاج",
    section_about_title: "لمسة فنية في التجميل",
    section_about_text: "رائد في علاجات الوجه والجسم غير الجراحية مع أكثر من 20 عامًا من الخبرة.",
    contact_title: "اتصال",
    contact_phone: "هاتف",
    contact_email: "بريد إلكتروني",
    contact_address: "عنوان",
    address: "ليفنت، إسطنبول",
    services: [
      { title: "علاجات الوجه", desc: "ميزوثيرابي، حشوات، شد بالخيوط، تجديد بالليزر." },
      { title: "علاجات الجسم", desc: "تنحيف موضعي، علاج السيلوليت، شد الجسم." },
      { title: "علاجات الشعر", desc: "PRP، ميزوثيرابي، علاج تساقط الشعر." },
      { title: "العناية بالبشرة", desc: "عناية فاخرة بالبشرة وعلاج التصبغات." },
    ],
    chat_title: "استشارة ذكية",
    chat_subtitle: "بلجين — المساعد الذكي للدكتور تيرمان",
    chat_placeholder: "اكتب سؤالك أو اضغط على المايكروفون...",
    chat_send: "إرسال",
    chat_listening: "يستمع...",
    chat_processing: "يعالج...",
    chat_voice_on: "الصوت مفعل",
    chat_voice_off: "الصوت معطل",
    lead_title: "معلومات الاتصال الخاصة بك",
    lead_sub: "كيف يمكننا الوصول إليك؟",
    lead_name: "الاسم الكامل",
    lead_method: "طريقة التواصل المفضلة",
    lead_phone: "هاتف",
    lead_email: "بريد إلكتروني",
    lead_whatsapp: "واتساب",
    lead_value: "بيانات التواصل",
    lead_submit: "إرسال",
    lead_thanks: "شكرا! سنتواصل معك قريبا.",
    welcome: "مرحبا 👋 أنا بلجين — المساعد الذكي للدكتور حسين تيرمان. يمكنني مساعدتك في العلاجات والأسعار والعروض والمواعيد. اسألني صوتيًا أو كتابيًا.",
  },
  ru: {
    nav_home: "Главная",
    nav_treatments: "Процедуры",
    nav_about: "О нас",
    nav_contact: "Контакты",
    hero_kicker: "НЕХИРУРГИЧЕСКОЕ ОМОЛОЖЕНИЕ",
    hero_title: "Заново открыть\nестественную красоту",
    hero_sub: "Персональная программа нехирургических процедур для лица и тела с доктором Хусейном Тырманом.",
    hero_cta: "Поговорить с ИИ-помощником",
    hero_secondary: "Услуги",
    section_services: "Направления",
    section_about_title: "Художественный подход в эстетике",
    section_about_text: "Более 20 лет опыта в нехирургических процедурах для лица и тела.",
    contact_title: "Контакты",
    contact_phone: "Телефон",
    contact_email: "Эл. почта",
    contact_address: "Адрес",
    address: "Левент, Стамбул",
    services: [
      { title: "Лицо", desc: "Мезотерапия, филлеры, нити, лазерное омоложение." },
      { title: "Тело", desc: "Похудение, целлюлит, подтяжка." },
      { title: "Волосы", desc: "PRP, мезотерапия, лечение выпадения." },
      { title: "Уход за кожей", desc: "Премиум-уход и лечение пигментации." },
    ],
    chat_title: "ИИ-консультация",
    chat_subtitle: "Бильгин — ИИ-помощник доктора Тырмана",
    chat_placeholder: "Напишите вопрос или нажмите микрофон...",
    chat_send: "Отправить",
    chat_listening: "Слушаю...",
    chat_processing: "Обработка...",
    chat_voice_on: "Голос вкл.",
    chat_voice_off: "Голос выкл.",
    lead_title: "Ваши контакты",
    lead_sub: "Как с вами связаться?",
    lead_name: "Имя",
    lead_method: "Предпочитаемый способ",
    lead_phone: "Телефон",
    lead_email: "Эл. почта",
    lead_whatsapp: "WhatsApp",
    lead_value: "Контакт",
    lead_submit: "Отправить",
    lead_thanks: "Спасибо! Мы скоро свяжемся.",
    welcome: "Здравствуйте 👋 Я Бильгин — ИИ-помощник доктора Хусейна Тырмана. Помогу с процедурами, ценами, акциями или записью. Спросите голосом или текстом.",
  },
};

export const LANG_OPTIONS = [
  { code: "tr", label: "Türkçe", flag: "🇹🇷" },
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "ar", label: "العربية", flag: "🇸🇦" },
  { code: "ru", label: "Русский", flag: "🇷🇺" },
];

export const isRtl = (lang) => lang === "ar";
